import { render } from "./cluster.vue?vue&type=template&id=8f450f2a"
import script from "./cluster.vue?vue&type=script&lang=js"
export * from "./cluster.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__